<div class="dashboard-container">

  <!-- <div class="tabs"> -->
  @if (!checkPatient() && currentConference && !recordingStarted) {
    <div (click)="startRecording()">
      <i class="fa fa-video-camera"></i>
    </div>
  }

  @if (!checkPatient() && currentConference && recordingStarted) {
    <div (click)="stopRecording()">
      <i class="fa fa-video-camera color-red"></i>
    </div>
  }
  <!-- <button [class.active]="activeTab==='all'" (click)="switchTab('all')">
  All Conferences
</button> -->
<!-- </div> -->

<!-- Current Conference Tab -->
@if (activeTab==='current') {
  <section class="current-tab">
    @if (currentConference) {
      <!-- Compact header -->
      <div class="conf-header">
        <span class="conf-title">{{ currentConference.topic }}</span>
        <span class="conf-time"
          >Created: {{ currentConference.created_at | date:'short' }}</span
          >
        </div>
        <!-- Max-height iframe -->
        <div class="embed-container">
          <iframe
            allow="microphone; camera; display-capture"
            [src]="joinEmbedUrl + '?autojoin=true&disable_name_prompt=true&ui_mode=embed&recording=true' | safeurl"
            frameborder="0"
            allowfullscreen>
          </iframe>
        </div>
      } @else {
        <div class="create-conf">
          <input type="text" placeholder="Conference topic" [(ngModel)]="newTopic" />
          <button (click)="createConference()">Create</button>
        </div>
      }
    </section>
  }

  <!-- All Conferences Tab -->
  @if (activeTab==='all') {
    <section class="all-tab">
      <h2>All Conferences</h2>
      <ul class="conf-list">
        @for (conf of allConferences; track conf) {
          <li (click)="selectConference(conf)">
            <strong>{{ conf.topic }}</strong><br/>
            <small>ID: {{ conf.id }}</small><br/>
            <small>Created: {{ conf.created_at | date:'short' }}</small>
          </li>
        }
      </ul>
    </section>
  }
</div>
